module.exports = __webpack_public_path__ + "img/Satisfaction.4755dabd.png";